var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHacHeaderLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,36.5c-0.3,0-0.5-0.1-0.7-0.4L9.5,21.5c-1.2-1.9-1.8-4-1.8-6.2C7.7,8.8,13.2,3.5,20,3.5 c6.8,0,12.3,5.3,12.3,11.9c0,2.2-0.6,4.3-1.8,6.1l-9.9,14.6C20.5,36.4,20.3,36.5,20,36.5L20,36.5z M20,5.2 c-5.9,0-10.7,4.6-10.7,10.2c0,1.9,0.5,3.7,1.5,5.3L20,34.2l9.1-13.6c1-1.6,1.5-3.4,1.5-5.2C30.7,9.7,25.9,5.2,20,5.2L20,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,20.9c-3.2,0-5.7-2.5-5.7-5.5c0-3.1,2.6-5.5,5.7-5.5s5.7,2.5,5.7,5.5C25.7,18.4,23.2,20.9,20,20.9L20,20.9z  M20,11.5c-2.2,0-4.1,1.7-4.1,3.9s1.8,3.9,4.1,3.9s4.1-1.7,4.1-3.9C24.1,13.2,22.2,11.5,20,11.5L20,11.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,34.3L26.1,23.6c3.9-4.7,3.7-11.7-0.7-16.1C23.1,5.2,20.1,4,16.9,4s-6.2,1.2-8.4,3.5 c-4.6,4.7-4.6,12.2,0,16.9c2.3,2.3,5.2,3.5,8.4,3.5c2.9,0,5.6-1,7.7-2.9l10.6,10.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 C37.1,35.3,37.1,34.7,36.7,34.3z M9.8,23.1c-3.9-4-3.9-10.4,0-14.4c1.9-1.9,4.5-3,7.2-3s5.2,1.1,7.2,3c3.9,4,3.9,10.4,0,14.4 c-1.9,1.9-4.5,3-7.2,3S11.7,25,9.8,23.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.4,34.8c-0.1,0-0.1,0-0.2,0l-10.5-2.6L4.1,34.8c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.5-0.2 C3.1,34.5,3,34.3,3,34V8.6c0-0.4,0.3-0.7,0.7-0.8l10.8-2.6l0.4,0l10.5,2.6l10.6-2.6c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.5,0.2 C36.9,5.5,37,5.7,37,6v25.4c0,0.4-0.3,0.7-0.7,0.8l-10.8,2.6C25.5,34.8,25.4,34.8,25.4,34.8L25.4,34.8z M15.5,30.7l9,2.2V9.3l-9-2.2 C15.5,7.1,15.5,30.7,15.5,30.7z M26.2,9.3v23.6l9-2.2V7.1L26.2,9.3z M4.7,9.3v23.6l9-2.2V7.1L4.7,9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacHeaderLocation);
export default __webpack_public_path__ + "static/media/hac_header_location.3e9bf820513562375b43eb19edd683d0.svg";
export { ForwardRef as ReactComponent };